import Icon from '../components/Icon.vue'

Icon.register({"compact-disc":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM88 256H56C56 150.1 142.1 64 248 64V96C159.8 96 88 167.8 88 256zM248 352C195 352 152 309 152 256S195 160 248 160 344 203 344 256 301 352 248 352zM248 224C230.3 224 216 238.3 216 256S230.3 288 248 288 280 273.7 280 256 265.7 224 248 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/compact-disc.js
// module id = tCid
// module chunks = 0